import { getConversationById } from '../../../helpers'
import { ChatState } from '../types'

export const onBackgroundConversationUpdateError = (
  state: ChatState,
  threadId: string
): ChatState => {
  const conversation = getConversationById(state.conversations, threadId)
  if (!conversation) {
    return state
  }

  return {
    ...state,
    conversations: {
      ...state.conversations,
      [conversation.id]: {
        ...conversation,
        updating: 'ERROR',
      },
    },
  }
}
